<div *ngIf="{ industryTree: industryTree$ | async, itemCount: itemCount$ | async, overlayVisible: overlayVisible$ | async, loading: loading$ | async} as data">
    <p-treeSelect
        #treeSelect
        [containerStyleClass]="isLarge && data.itemCount > 0 ? 'tree-select-searchPage-selected': isLarge && data.itemCount === 0 ? 'tree-select-searchPage-not-selected': !isLarge && data.itemCount > 0 ? 'tree-select-selected' : 'tree-select'"
        [formControl]="treeSelectControl"
        [options]="data.industryTree"
        [metaKeySelection]="true"
        selectionMode="checkbox"
        placeholder="Select Item"
        [scrollHeight]="scrollHeight"
        [filter]="true"
        [showClear]="true"
        [emptyMessage]="notFoundTextMessage | translate"
        [resetFilterOnHide]="true"
        [filterInputAutoFocus]="false"
        (onShow)="onShow($event)"
        (onHide)="onHide($event)"
        (onNodeSelect)="onSelectNode($event)"
        (onNodeUnselect)="onUnSelectNode($event)"
        [disabled]="disabled"
        [appendTo]="appendTo">

        <!-- (onNodeSelect)="onSelectNode($event)"
        (onNodeUnselect)="onUnSelectNode($event)"
        (onClear)="onClear()"
        (onHide)="onHide($event)"
        (onShow)="onShow($event)" -->
    
        <ng-template #triggericon>
           <div class="dropdwon-icon">
            <svg-icon src="/assets/icons/arrow-up.svg" *ngIf="data.overlayVisible" [svgClass]="'arrow-class'"></svg-icon>
            <svg-icon src="/assets/icons/arrow-down.svg" *ngIf="!data.overlayVisible" [svgClass]="'arrow-class'"></svg-icon>
           </div>
        </ng-template>

        <ng-template pTemplate="itemloadingicon">
            <hrra-tree-select-spinner></hrra-tree-select-spinner>
        </ng-template>
        <ng-template pTemplate="empty">
            <div *ngIf="data.loading" style="text-align: center; height: 7rem;" >
                <hrra-tree-select-spinner></hrra-tree-select-spinner>
            </div>
        </ng-template>

        <ng-template pTemplate="itemtogglericon" let-open>
            <svg-icon *ngIf="open" src="/assets/icons/arrow-up.svg" class="arrow-icon"></svg-icon>
            <svg-icon *ngIf="!open" src="/assets/icons/arrow-down.svg" class="arrow-icon"></svg-icon>
        </ng-template>

        <ng-template #clearicon>
            <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
        </ng-template>

        <ng-template pTemplate="filtericon">
            <svg-icon src="/assets/icons/search-small.svg" class="search-icon"></svg-icon>
        </ng-template>

        <ng-template pTemplate="value" let-node>
            <span *ngIf="data.itemCount == 0" [ngClass]="isLarge ? 'tree-select-value-searchPage tree-select-value-searchPage__grey':'tree-select-value tree-select-value__grey'" [title]="(placeHolderTextMessage | translate )">{{ placeHolderTextMessage | translate }}</span>
            <span *ngIf="data.itemCount > 0" [ngClass]="isLarge ? 'tree-select-value-searchPage tree-select-value-searchPage__primary-green': 'tree-select-value tree-select-value__primary-green'" [title]="(selectedItemCountText | translate : {count: data.itemCount})">{{ selectedItemCountText | translate : {count: data.itemCount} }}</span>
        </ng-template>

        <ng-template #footer>
            <div class="footer">
                <button type="button" class="footer__reset-button" (click)="onReset()">{{ 'label.ClearFilter' | translate }}</button>
                <button type="button" class="footer__approve-button" (click)="onApprove()">{{ 'label.Approve' | translate }}</button>
            </div>
        </ng-template>
    </p-treeSelect>
</div>